<template>
  <div>
    <app-cells>
      <h1 class="title">Snack bar</h1>
    </app-cells>
    <app-tabs :tabs="visibleTabs" />
    <transition name="fade" mode="out-in">
      <router-view  />
    </transition>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'
import { refundRoles, snackbarOperationsRoles, hasSafariRole } from '@/utils/safariRefundAccess'

export default {
  name: 'SafariSnackBarLayout',
  components: { AppTabs },
  computed: {
    visibleTabs() { return this.tabs.filter(tab => hasSafariRole(this.$store.state.userGroups, tab.roles)) }
  },
  data() {
    return {
      tabs: [
        { name: 'safari-snack-bar', label: 'Upcoming', roles: snackbarOperationsRoles },
        { name: 'safari-snack-bar-tour', label: 'In tour', roles: snackbarOperationsRoles },
        { name: 'safari-snack-bar-archive', label: 'Archive', roles: snackbarOperationsRoles },
        { name: 'safari-snackbar-refunds', label: 'Refunds', roles: refundRoles },
      ],
    }
  },
}
</script>
